export const POSITION_OPTIONS = [
  { value: "Top", label: "Top" },
  { value: "Featured", label: "Featured" },
];

export const CONTENT_REDIRECT_OPTIONS = [
  { value: "show_all", label: "Show All Content" },
  { value: "specific_catalog", label: "Specific Catalog" },
  { value: "specific_bundle", label: "Specific Bundle" },
  { value: "specific_content", label: "Specific Content" },
];

export const TARGET_DEVICE_OPTIONS = [
  {
    value: "mobile",
    label: "Mobile (iOS & Android)",
    recommendedSize: "600×200px",
  },
  {
    value: "tablet",
    label: "Tablet (iOS & Android)",
    recommendedSize: "1200×400px",
  },
  { value: "windows", label: "Windows", recommendedSize: "1200×400px" },
];

/**
 * type: "multiselect" | "checkbox" | "text" | "number"
 * masterDataKey: key in masterDataValue.result to derive options from (dynamic)
 * valueKey: id field name used when mapping master data entries (e.g. "subscriberTypeId")
 * staticOptions: hardcoded { value, label }[] when no master data is available
 */
export const TARGETING_FIELDS = [
  {
    key: "subscriberType",
    label: "Subscriber Type",
    type: "multiselect",
    masterDataKey: "subscriberTypes",
    valueKey: "subscriberTypeId",
  },
  {
    key: "carriersRepresented",
    label: "Carriers Represented",
    type: "multiselect",
    masterDataKey: "carrierRepresents",
    valueKey: "carrierRepresentId",
  },
  {
    key: "majorAreas",
    label: "Major Areas",
    type: "multiselect",
    masterDataKey: "areas",
    valueKey: "areaId",
  },
  { key: "numberOfProducers", label: "Number of Producers", type: "number" },
  {
    key: "industryGroups",
    label: "Industry Groups / Membership",
    type: "multiselect",
    masterDataKey: "industryGroups",
    valueKey: "industryGroupId",
  },
  {
    key: "technologyBeingUsed",
    label: "Technology Being Used Now",
    type: "multiselect",
    masterDataKey: "technologies",
    valueKey: "technologyId",
  },
  { key: "yearsInBusiness", label: "Years in Business", type: "number" },
  {
    key: "annualRevenue",
    label: "Annual Revenue",
    type: "singleselect",
    masterDataKey: "annualRevenue",
    valueKey: "annualRevenueId",
    labelKey: "name",
  },
  {
    key: "numberOfEmployees",
    label: "Number of Employees",
    type: "singleselect",
    masterDataKey: "numberOfEmployees",
    valueKey: "value",
    labelKey: "text",
  },
  {
    key: "numberOfPrincipals",
    label: "Number of Principals / Owners",
    type: "number",
  },
  {
    key: "country",
    label: "Country",
    type: "multiselect",
    masterDataKey: "countries",
    valueKey: "countryId",
  },
  {
    key: "state",
    label: "State",
    type: "multiselect",
    masterDataKey: "states",
    valueKey: "stateId",
  },
  { key: "city", label: "City", type: "text" },
  { key: "zip", label: "Zip", type: "text" },
];

export const EMPTY_TARGETING = Object.fromEntries(
  TARGETING_FIELDS.map((f) => [f.key, f.type === "text" ? "" : []]),
);

export const PRICE_PER_DAY = { Top: 5, Featured: 3 };
